<lib-chat-navbar
  [date]="
    channelDetails()?.closestGame
      ? (channelDetails()!.closestGame!.gameDateStart | dateFormat: channelDetails()!.closestGame!.gameDateEnd)
      : 'Brak najbliższej gierki'
  "
  [details]="channelDetails()"
  [hideActions]="isPending()"
  (onDotsClicked)="manageChannel()"
  (actionOnBack)="stopWatching()"></lib-chat-navbar>
@if (isPageLoaded()) {
  @if (isPending()) {
    <lib-custom-message-input></lib-custom-message-input>
  } @else {
    <stream-channel>
      <lib-custom-message-list></lib-custom-message-list>
      <lib-custom-message-input></lib-custom-message-input>
    </stream-channel>
  }
}
